<template>
  <el-container class="PersonnelVehicleInformation">
    <!-- 单位信息 -->
    <div class="tabs-card">
      <h3 :style="{ 'margin-bottom': '10px' }">从业人员</h3>
      <el-form
        :disabled="status === 3"
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-row>
          <el-col style="display: flex; align-items: center">
            <el-select
              style="margin-right: 20px"
              @change="selectChange"
              placeholder="新建"
            >
              <el-option
                v-for="item in [
                  { value: '1', label: '选择实有人' },
                  { value: '2', label: '新建居住人' },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <h-button type="danger" @click="delUser">删除</h-button>
            <!-- <h-button type="primary">导入</h-button>
            <h-button type="primary">导出</h-button> -->
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          :disabled="status === 3"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="unitSelectPrison"
          :params="tableParams"
          :showPopover="false"
          :autoload="status !== 1"
          @handleClick="handleClick"
          @select="hzTableSelect"
          style="height: 400px"
        >
          <template #name="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.name }}</span>
            </div>
          </template>
        </h-table>
      </div>
    </div>
    <el-dialog
      v-model="houseTwoSYRVisible"
      title="选择实有人口"
      width="43%"
      height="40%"
    >
      <houseTwoSYR
        v-if="houseTwoSYRVisible"
        v-model="houseTwoSYRVisible"
        @submitList="submitList"
        :form="userFormData"
        :status="formStatus"
        @submit="userSubmit"
      ></houseTwoSYR>
    </el-dialog>
    <el-dialog
      v-model="houseTwoJZRVisible"
      :title="
        '人口' +
        (formStatus === 1 ? '新增' : formStatus === 2 ? '编辑' : '详情')
      "
      width="43%"
      height="40%"
    >
      <personnel-detail
        v-if="houseTwoJZRVisible"
        v-model="houseTwoJZRVisible"
        :form="userFormData"
        :status="formStatus"
        @userSubmitOver="userSubmitOver"
      ></personnel-detail>
    </el-dialog>
  </el-container>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  watchEffect,
  onMounted,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { unitsavePrison, unitdeletePrison } from "@/api/management/management";
import {
  queryUserList,
  unitSelectPrison,
  infoQuery,
} from "@/api/realPopulation/realPopulation.js";

import houseTwoSYR from "./unitltTwoSYR.vue";
import _ from "lodash";
export default defineComponent({
  name: "PersonnelVehicleInformation",
  components: { houseTwoSYR },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  setup(props, context) {
    const state = reactive({
      filterText: "",
      houseTwoSYRVisible: false,
      houseTwoJZRVisible: false,
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      userFormData: {},
      tableParams: {
        // regionId: props.form.regionId,
        unitId: props.form.unitId,
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "姓名",
          slot: "name",
        },
        {
          label: "性别",
          prop: "sexDict",
        },
        {
          label: "民族",
          prop: "nationDict",
        },
        {
          label: "出生日期",
          prop: "birthday",
        },
        {
          label: "电话",
          prop: "telphone",
        },
        {
          label: "更新时间",
          prop: "jzdz",
        },
        // {
        //   type: "operate",
        //   label: "操作",
        //   width: "140px",
        //   operates: [
        //     // { name: "编辑", emitKey: "edit" },
        //     { name: "删除", emitKey: "del", type: "danger" },
        //   ],
        // },
      ],
    });

    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    // const formRef = ref(null);
    watchEffect(() => {
      console.log(props.form, 99999999999);
    });
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.deptId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row, index) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        // state.userFormData.roleIdList = row.roleList.map(item => item.roleId);
        state.formVisible = true;
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync(index);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    const deleteUserAsync = async (idArr) => {
      if (Array.isArray(idArr)) {
        const params = {
          unitId: props.form.unitId,
          ids: idArr,
        };
        const res = await unitdeletePrison(params);
        if (res.code == 0) {
          refreshTable();
          ElMessage({
            type: "success",
            message: "删除成功",
          });
        }
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.prisonId);
            if (props.status === 1) {
              tableRef.value.tableData = tableRef.value.tableData.filter(
                (item) => {
                  if (!ids.includes(item.prisonId)) return item;
                }
              );
              context.emit("emitSelectPerson", tableRef.value.tableData);
            } else {
              deleteUserAsync(ids);
            }
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的用户",
        });
      }
    };
    const submitunilTwo = () => {
      if (props.status === 1) {
      } else {
        state.tableParams.unitId = props.form.unitId;
        refreshTable();
      }
    };
    // 选择然后选择对应的弹框
    const selectChange = (val) => {
      // 1选择实有人 2新建居住人
      if (val === "1") {
        state.houseTwoSYRVisible = true;
      } else {
        state.userFormData = {};
        state.houseTwoJZRVisible = true;
        state.formStatus = 1;
      }
    };
    const submitTwo = async (val) => {
      const prisonerIds = val.map((item) => {
        return item.prisonId;
      });
      const params = {
        unitId: props.form.unitId,
        prisonerIds,
      };
      const res = await unitsavePrison(params);
      if (res.code === 0) {
        refreshTable();
        // context.emit("clone", state.formVisible);
        // context.emit("update:modelValue", state.formVisible);
      }
    };
    const submitList = (val) => {
      if (props.status === 1) {
        tableRef.value.tableData = tableRef.value.tableData.concat(val);
        tableRef.value.tableData = tableRef.value.tableData.filter(
          (element, index, self) => {
            return (
              self.findIndex((x) => x.prisonId === element.prisonId) === index
            );
          }
        );
        context.emit("emitSelectPerson", tableRef.value.tableData);
      } else {
        submitTwo(val);
      }
    };
    const clickTable = async (item) => {
      state.userFormData = _.cloneDeep(item);
      state.userFormData.houseId = props.form.houseId;
      state.formStatus = 3;
      state.houseTwoJZRVisible = true;
    };
    const userSubmitOver = async (prisonerId) => {
      if (props.status === 1) {
        const res = await infoQuery(prisonerId);
        submitList(res.prisonInfo);
      } else {
        submitTwo([{ prisonId: prisonerId }]);
      }
    };
    return {
      ...refData,
      clickTable,
      submitList,
      selectChange,
      submitTwo,
      filterNode,
      currentChange,
      refreshTable,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      queryUserList,
      unitSelectPrison,
      userSubmit,
      submitunilTwo,
      tableRef,
      userSubmitOver,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  height: 550px;
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      height: 100%;
      overflow: hidden;
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
